import { SITE_ID } from './index'

const siteIdByCountryId = [
  { id: 1, siteId: SITE_ID === 'ZJAR' ? 'ZJAR' : 'BMAR' },
  { id: 1007, siteId: 'BMCL' },
  { id: 9, siteId: 'BMEC' },
  { id: 18, siteId: 'BMMX' },
  { id: 20, siteId: 'BMPA' },
  { id: 11, siteId: 'BMPE' },
  { id: 13, siteId: 'BMVE' },
]

export default siteIdByCountryId
